/*
 * <quick-add-size> : ajout rapide sur les cartes produit (Well Worn London).
 * Reecrit le 2026-09-11. Le "+" ouvre et ferme le panneau de tailles ;
 * un toucher sur une taille ajoute la variante au panier et ouvre le
 * tiroir du theme (meme flux que product-form.js). Le panneau se ferme
 * au clic hors de la carte et a la touche Echap. Un seul panneau ouvert
 * a la fois. Sur ordinateur le survol de la carte suffit (CSS).
 */
if (!customElements.get('quick-add-size')) {
  customElements.define(
    'quick-add-size',
    class QuickAddSize extends HTMLElement {
      constructor() {
        super();
        this.trigger = this.querySelector('.quick-add-size__trigger');
        this.panel = this.querySelector('.quick-add-size__panel');
        this.spinner = this.querySelector('.loading__spinner');
        this.errorWrapper = this.querySelector('.product-form__error-message-wrapper');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.loading = false;

        if (this.trigger) this.trigger.addEventListener('click', this.onTrigger.bind(this));
        this.addEventListener('click', this.onOptionClick.bind(this));
        QuickAddSize.bindGlobal();
      }

      static bindGlobal() {
        if (QuickAddSize.bound) return;
        QuickAddSize.bound = true;
        document.addEventListener('click', (event) => {
          document.querySelectorAll('quick-add-size.is-open').forEach((el) => {
            if (!el.contains(event.target)) el.close();
          });
        });
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') document.querySelectorAll('quick-add-size.is-open').forEach((el) => el.close());
        });
      }

      open() {
        document.querySelectorAll('quick-add-size.is-open').forEach((el) => { if (el !== this) el.close(); });
        this.classList.add('is-open');
        if (this.trigger) this.trigger.setAttribute('aria-expanded', 'true');
      }

      close() {
        this.classList.remove('is-open');
        if (this.trigger) this.trigger.setAttribute('aria-expanded', 'false');
        this.showError(false);
      }

      onTrigger(event) {
        event.preventDefault();
        event.stopPropagation();
        if (this.classList.contains('quick-add-size--single')) {
          const single = this.querySelector('.quick-add-size__option--single');
          if (single) { this.addToCart(single.dataset.variantId, single); return; }
        }
        this.classList.contains('is-open') ? this.close() : this.open();
      }

      onOptionClick(event) {
        const button = event.target.closest('.quick-add-size__option');
        if (!button || button.hasAttribute('disabled') || this.loading) return;
        event.preventDefault();
        event.stopPropagation();
        this.addToCart(button.dataset.variantId, button);
      }

      setLoading(state, button) {
        this.loading = state;
        this.classList.toggle('is-loading', state);
        if (this.spinner) this.spinner.classList.toggle('hidden', !state);
        if (button) button.classList.toggle('loading', state);
      }

      showError(message) {
        if (!this.errorWrapper) return;
        this.errorWrapper.toggleAttribute('hidden', !message);
        const el = this.errorWrapper.querySelector('.product-form__error-message');
        if (el && message) el.textContent = message;
      }

      addToCart(variantId, button) {
        if (!variantId) return;
        this.showError(false);
        this.setLoading(true, button);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', 1);
        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          if (typeof this.cart.setActiveElement === 'function') this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.showError(response.description || response.message);
              if (typeof publish === 'function') {
                publish(PUB_SUB_EVENTS.cartError, { source: 'quick-add-size', productVariantId: variantId, errors: response.errors || response.description, message: response.message });
              }
              return;
            }
            if (!this.cart) { window.location = window.routes.cart_url; return; }
            if (typeof publish === 'function') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quick-add-size', productVariantId: variantId, cartData: response });
            }
            if (this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            this.cart.renderContents(response);
            this.close();
          })
          .catch((e) => { console.error(e); this.showError(); })
          .finally(() => { this.setLoading(false, button); });
      }
    }
  );
}
